import React from 'react'
import {useSelector} from 'react-redux'

const memberHeaderCss = {
  padding: '100px 15px',
  background: 'linear-gradient(336deg, #c08c20, #265544)',
  color: '#fff'
}

const MemberHeader = ({title,subTitle}) => {

  const {first_name,last_name,affiliation,role,photo} = useSelector(s=>s.auth)

  return (
    <div id="member-head" style={memberHeaderCss}>
      <div className="container">
        <div className="row">
          <div className="col">
            <h1 style={{fontWeight: 800}}>{title}</h1>
            <p role="presentation" onClick={()=>{
              window.location.href = `/member/account`
            }} style={{fontSize: 18,display:'table',paddingTop:15,marginTop:35,lineHeight:'1.3',cursor:'pointer'}}>
              <span style={{display:'table-cell',verticalAlign:'middle'}}>
                {
                  /*
                  <img src="https://i0.wp.com/events.globallandscapesforum.org/wp-content/uploads/sites/2/2022/03/aZKQQ56G_400x400.jpeg?resize=150%2C150&amp;ssl=1&amp;is-pending-load=1"
                  style={{width:60,height:60,borderRadius:'100%'}}/>
                  */
                }
                {
                  photo ? (
                    <img src={`/photo/${photo}`}
                    style={{width:50,height:50,borderRadius:'100%'}}/>
                  ) : <i className="fa fa-user-circle" style={{fontSize: 50}}/>
                }
              </span>

              <span style={{display:'table-cell',verticalAlign:'middle',paddingLeft:15}}>
                <b>{`${first_name}${last_name ? ` ${last_name}` : ''}`}</b>{affiliation ? ` - ${affiliation}` : ''}
                <br/>
                <span style={{opacity:0.7,fontSize:12,fontWeight:700,letterSpacing:1,textTransform:'uppercase'}}>
                  {
                    role === "ROLE_ADMIN" ? 'Administrator' : (role === "ROLE_EDITOR" ? 'Data editor' : (role === "ROLE_CONTRIBUTOR" ? 'Data contributor' : 'Public user'))
                  }
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
export default MemberHeader
